import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./about.module.css";

export const About = ({ slice }) => {
  const { heading, copy } = slice?.primary || {};

  return (
    <section data-color-scheme="black" data-tilt-scheme="left" id="about">
      <div className={"section-split page-width " + styles.inner}>
        <motion.div
          className={"padding-section-vertical " + styles.content}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {copy && <PrismicRichText field={copy.richText} />}
        </motion.div>
        <motion.div
          className={styles.graphic}
          initial={{ opacity: 0, scale: 0.9, rotate: -5 }}
          whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {heading && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h1">{children}</h2>,
              }}
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyAbout on PrismicHomepageDataBodyAbout {
    primary {
      heading {
        richText
      }
      copy {
        richText
      }
    }
  }
`;
